import { useRef } from "react";

const listChanged = (prev: string[], next: string[]) => {
  if (prev.length !== next.length) return true;
  for (let i = 0; i < prev.length; i++) {
    if (prev[i] !== next[i]) return true;
  }
  return false;
};

/** Receives an array of objects (e.g., `AgendaModules`, `AgendaItems`, `Documents`, etc. - anything with `id`),
 * and returns that newly passed array if the array length or ids of the objects changed. Otherwise, returns the old, unchanged array object.
 * This is used to prevent re-rendering components using `memo()` that are passed data object arrays. */
export const useMemoObjectList = <T extends { id: string }>(list?: T[]) => {
  const state = useRef({ lastIds: [] as string[], lastList: [] as T[] });

  list ??= [];
  const ids = list.map((object) => object.id);

  if (listChanged(state.current.lastIds, ids)) {
    state.current.lastIds = ids;
    state.current.lastList = list;
  }

  return state.current.lastList;
};
